import React, { ReactElement } from 'react';
import { DiagnosisCategoryHook } from '../../hooks/diagnosis/diagnosis-category.hook';
import Header from '../../components/Header';

export default function DiagnosisListPage(): ReactElement {
	return (
		<>
			<Header />
			<div className="p-8 sm:p-2 sm:w-screen mt-16 sm:mt-7 min-h-screen max-w-screen-lg px-[125px] sm:px-5">
				<DiagnosisCategoryHook />
				<div className="button-wrap mt-12 sm:mt-5 sm:p-10 sm:pt-0"></div>
			</div>
		</>
	);
}
